import React from 'react'

export type MessageType = 'info' | 'success' | 'error' | 'warning'
export interface MessageProps {
    text: string
    type: MessageType
}
const Notice: React.FC<MessageProps> = (props: MessageProps) => {
    const { text, type } = props
    return (
        <div className='message-notice'>
            <div className='message-notice-content'>
                <div
                    className={`message-custom-content message-custom-${type}`}
                >
                    {/* <span className="icon">{type}</span> */}
                    <span className='text'>{text}</span>
                </div>
            </div>
        </div>
    )
}
export default Notice
